"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _formik = require("formik");

var _Button = _interopRequireDefault(require("../../Button/Button"));

var _themeContants = require("../../../constants/themeContants");

var _reactTraverse = _interopRequireDefault(require("react-traverse"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Yup = require("yup");

var findFormFields = function findFormFields(node) {
  var startFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var formFields = startFields;

  var isFormField = function isFormField(name) {
    return name === "FormField";
  };

  (0, _reactTraverse["default"])(node, {
    ComponentElement: function ComponentElement(path) {
      if (isFormField(path.node.type.name)) {
        formFields.push(path.node);
      }

      path.traverseChildren();
    }
  });
  return formFields;
};

var Form =
/*#__PURE__*/
function (_Component) {
  _inherits(Form, _Component);

  function Form() {
    _classCallCheck(this, Form);

    return _possibleConstructorReturn(this, _getPrototypeOf(Form).apply(this, arguments));
  }

  _createClass(Form, [{
    key: "render",
    value: function render() {
      var _this = this;

      var formFields = findFormFields(this.props.children);
      var validationShape = formFields.reduce(function (validator, curr) {
        var _curr$props = curr.props,
            type = _curr$props.type,
            required = _curr$props.required,
            nullable = _curr$props.nullable,
            name = _curr$props.name,
            min = _curr$props.min,
            max = _curr$props.max,
            integer = _curr$props.integer;

        switch (type) {
          case "string":
            {
              validator[name] = Yup.string();
              break;
            }

          case "number":
            {
              validator[name] = Yup.number();

              if (min) {
                validator[name] = validator[name].min(min);
              }

              if (max) {
                validator[name] = validator[name].max(max);
              }

              if (integer) {
                validator[name] = validator[name].integer();
              }

              break;
            }

          case "bool":
            {
              validator[name] = Yup.bool();
              break;
            }

          case "email":
            {
              validator[name] = Yup.string().email();
              break;
            }

          case "date":
            {
              validator[name] = Yup.date();
              break;
            }

          case "url":
            {
              validator[name] = Yup.string().url();
              break;
            }

          default:
            {
              validator[name] = Yup.string();
              break;
            }
        }

        if (nullable) {
          validator[name] = validator[name].nullable();
        }

        if (required) {
          validator[name] = validator[name].required("Denne må du ha");
        }

        return validator;
      }, {});
      var validationSchema = Yup.object().shape(validationShape);
      var Container = this.props.Container;
      return _react["default"].createElement(_formik.Formik, {
        initialValues: this.props.initialValues,
        validationSchema: validationSchema,
        onSubmit: this.props.onSubmit,
        render: function render(_ref) {
          var handleSubmit = _ref.handleSubmit,
              values = _ref.values,
              isValid = _ref.isValid,
              errors = _ref.errors,
              touched = _ref.touched;
          return _react["default"].createElement("form", {
            onSubmit: handleSubmit
          }, Container && _react["default"].createElement(Container, _this.props.containerProps, _this.props.children, _this.props.renderButton ? _this.props.renderButton({
            values: values,
            isValid: isValid,
            errors: errors,
            touched: touched
          }) : _react["default"].createElement(_Button["default"], {
            type: "submit",
            onClick: function onClick() {
              return null;
            }
          }, _this.props.buttonText)), !Container && _react["default"].createElement(_react["default"].Fragment, null, _this.props.children, _this.props.renderButton ? _this.props.renderButton({
            values: values,
            isValid: isValid,
            errors: errors
          }) : _react["default"].createElement(_Button["default"], {
            type: "submit",
            onClick: function onClick() {
              return null;
            }
          }, _this.props.buttonText)));
        }
      });
    }
  }]);

  return Form;
}(_react.Component);

Form.propTypes = {
  children: _themeContants.commonPropTypes.children.isRequired,
  initialValues: _propTypes["default"].object,
  onSubmit: _propTypes["default"].func,
  renderButton: _propTypes["default"].func
};
Form.defaultProps = {
  initialValues: {},
  onSubmit: console.log,
  containerProps: {}
};
var _default = Form;
exports["default"] = _default;